module.exports = {
    "isAnimation": true,
    "isLoop": true,
    "frames": [
        {
            "time": 0,
            "image": require("./donna_idle_0000.png").default
        },
        {
            "time": 200,
            "image": require("./donna_idle_0200.png").default
        },
        {
            "time": 400,
            "image": require("./donna_idle_0400.png").default
        },
        {
            "time": 600,
            "image": require("./donna_idle_0600.png").default
        },
        {
            "time": 800,
            "image": require("./donna_idle_0800.png").default
        },
        {
            "time": 1000,
            "image": require("./donna_idle_1000.png").default
        },
        {
            "time": 1200,
            "image": require("./donna_idle_0000.png").default
        },
    ]
}
